export default __webpack_public_path__ + "static/media/ge.6ff06a6f.svg";